import { mealyModelAmpel } from "./AmpelSystem/mealyModelAmpel";
import { mealyModelCodeschloss } from "./Codeschloss/mealyModelCodeschloss";
import { mealyModelDoorSystem } from "./DoorSystem/mealyModelDoorSystem";
import { mealyModelGaragentor } from "./Garagentor/mealyModelGaragentor";
import { mealyModelKunstautomat1 } from "./Kunstautomat/mealyModelKunstautomat";
import { mealyModelKunstautomat2 } from "./Kunstautomat/mealyModelKunstautomat";
export function mealyModelByType(mealyModelType) {
    switch (mealyModelType) {
        case 'DoorSystem':
            return mealyModelDoorSystem;
        case 'Kunstautomat1':
            return mealyModelKunstautomat1;
        case 'Kunstautomat2':
            return mealyModelKunstautomat2;
        case 'AmpelSystem':
            return mealyModelAmpel;
        case 'Garagentor':
            return mealyModelGaragentor;
        case 'Codeschloss':
            return mealyModelCodeschloss;
        default:
            throw new Error('not implemented yet');
        // case 'Kara':
        //     return mealyModelKara;
        // return exhaustiveCheck(mealyModelType);
    }
}
